import { fileSize } from '@bettermode/common/filesize'
import { File } from '@tribeplatform/gql-client/types'

import { FileTypeIcon } from '../../../common/components/FileTypeIcon/FileTypeIcon.js'
import { ChatAttachment } from '../../types.js'

interface Props {
  attachment: ChatAttachment
}

export const ComposerFileAttachmentItem = ({ attachment }: Props) => {
  const file = (attachment.uploadedFile as File | undefined) ?? attachment.file
  const fileExtension = file.name.split('.').pop()

  return (
    <div className="flex items-center gap-2 p-2">
      <FileTypeIcon extension={fileExtension} className="w-[30px] h-[30px]" />
      <div className="flex flex-col max-w-[150px]">
        <div className="truncate">{file.name}</div>
        <div className="text-content-subdued text-start text-xs">
          {fileSize(file.size)}
        </div>
      </div>
    </div>
  )
}
